import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppRoutes, CompareLinks, NavLinks } from '@app/core/routing';
import { PLATFORM_LOGO_SRC } from '@app/core/site-context';
import { UiModule } from '@app/ui';
import { LayoutContext } from '../../../../layout-context.model';

@Component({
  selector: 'gb-footer-platform',
  standalone: true,
  imports: [RouterLink, UiModule],
  templateUrl: './footer-platform.component.html',
  styleUrls: ['./footer-platform.component.scss'],
})
export class FooterPlatformComponent {
  protected readonly AppRoutes = AppRoutes;
  protected readonly NavLinks = NavLinks;
  protected readonly CompareLinks = CompareLinks;

  /** Only supplied when rendered as a layout slot; unset for direct page use. */
  @Input() ctx?: LayoutContext;

  readonly platformLogoSrc = PLATFORM_LOGO_SRC;
  readonly year = new Date().getFullYear();
}
